import get from 'lodash/get';
import fetch from 'isomorphic-fetch';

import { isMobile } from '~/genericFunctions';

import { responseReceived } from './lib/mobile-x';

const webOrMobile = (ismobile) => isMobile(ismobile) ? 'MOBILE' : 'WEB';

const getHeaders = ({ globalData: { ismobile, locale } }) => ({
  'Content-Type': 'text/javascript',
  'Content-Encoding': 'gzip',
  'X-HSBC-Channel-Id': webOrMobile(ismobile),
  'X-HSBC-Locale': locale,
  'X-HSBC-Chnl-CountryCode': 'MX',
  'X-HSBC-Chnl-Group-Member': 'HBMX',
  'X-Content-Type-Options': 'nosniff',
});

export const fetchOffers = async ({ globalData, url }) => {
  let response = await fetch(url, {
    method: 'get',
    headers: getHeaders({
      globalData,
    }),
  });
  if (isMobile(get(globalData, 'ismobile'))) {
    responseReceived(response.status);
  }
  if (!response.ok) {
    throw Error(response.statusText);
  }
  let data = await response.json();
  return data;
};
